<template>
  <div id="reviews" class="bg-sky_grey_darker py-16">
    <div class="container mx-auto px-4">
      <h2 class="text-2xl font-bold mb-6">
        Les avis de nos clients
      </h2>
      <div v-if="product.properties.reviews && product.properties.reviews.total" class="flex items-start flex-wrap">
        <div class="flex-1">
          <div v-for="(i, reviewIndex) in product.properties.reviews.hits" :key="reviewIndex + '-review'" class="bg-white mb-3 p-8 lg:mr-4">
            <div class="flex justify-between items-center mb-3">
              <div class="md:flex items-center">
                <strong class="mr-3">
                  <template v-if="i.customer_name">
                    {{ capitalizeReviewName(i.customer_name) }}
                  </template>
                  <template v-else>
                    Client Anonyme
                  </template>
                </strong>
                <notation class="mr-2" :notation="i.rating * 5" :max="5" />
              </div>
              <div class="text-sky_grey text-xs">
                Publié le {{ $helpers.formatDate(i.created_at) }}
              </div>
            </div>
            <div class="text-sm">
              {{ i.review }}
            </div>
          </div>
        </div>
        <div class="sky__product-reviews-recap bg-sky_blue text-white text-center px-10 py-6 order-first lg:order-none mb-4 lg:mb-0">
          <div class="mb-3">
            <etoiles-avis style="width: 100%;" />
          </div>
          <div class="font-funny text-3xl">
            Note globale: {{ (product.properties.reviews.avg).toFixed(1) }}/5
          </div>
          <div class="text-sm">
            Sur {{ product.properties.reviews.total }} avis Client certifiés
          </div>
        </div>
      </div>
      <div v-else>
        <div class="bg-sky_blue text-white text-center px-10 py-6 mb-4 lg:mb-0">
          <div class="mb-3 mx-auto" style="width: 200px;">
            <etoiles-avis style="width: 100%;" />
          </div>
          <div class="font-funny text-3xl">
            Il n'y a encore aucun avis sur ce produit.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EtoilesAvis from '../../assets/icons/etoiles-avis.svg'
import Notation from './Notation'
export default {
  components: {
    Notation,
    EtoilesAvis
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  methods: {
    capitalizeReviewName (n) {
      return n.split(' ').map((name) => {
        return name.charAt(0).toUpperCase() + name.slice(1)
      }).join(' ')
    }
  }
}
</script>
